export const aboutYou = {
  header: `Your Investing Profile`,
  aboutYouIntro: `We need to learn more about your investment experience, preferences, and objectives to gauge if this investment is appropriate for you.`,
  nextQuestions: `Next, we’ll ask you questions about your investing experience and preferences to build your investing profile.`,
  continueBelow: `Continue below when ready.`,
}
